import protoRoot from "../proto-root";
import BabyStationState from "../private/BabyStationState";

const name = "syncFromBSRpcResponse";

function create({ babyStationState }) {
  const SyncFromBSRPCResponse = protoRoot.lookupType(
    "comm.SyncFromBSRPCResponse"
  );

  return {
    payload: SyncFromBSRPCResponse.create({
      babyStationState: BabyStationState.create(babyStationState)
    }),
    name,
    sendBy: "xmpp"
  };
}

export default {
  create,
  name
};
